import React from "react";


const Footer = () => {
    return (
        <div className="footer-2">
            <div className="container">
                <p>
                    <span>Food Labs </span>&nbsp;<i className="fas fa-copyright"></i>&nbsp;2022 | All Rights Reserved
                </p>
            </div>
        </div>
    );
}

export default Footer;